import { BaseQueryFn, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setAuthToken } from "../../app/rootReducer";
import { RootState } from "../../app/store";
import { getStoredAccessToken, refreshAccessTokenOnce } from "./authRefresh";

type ApiBaseQueryExtraOptions = {
    _retry?: boolean;
};

const rawBaseQuery = fetchBaseQuery({
    baseUrl: import.meta.env.VITE_ADMIN_URL as string,
    prepareHeaders: (headers, { getState }) => {
        const { root } = getState() as RootState;
        const { authToken } = root;
        if (authToken) {
            headers.set("Authorization", `Bearer ${authToken}`);
        }
        return headers;
    },
});

export function apiBaseQuery(): BaseQueryFn {
    return async (args, api, extraOptions) => {
        const options = (extraOptions ?? {}) as ApiBaseQueryExtraOptions;
        const result = await rawBaseQuery(args, api, extraOptions);

        if (result.error?.status !== 401 || options._retry) {
            return result;
        }

        try {
            await refreshAccessTokenOnce();
            const newToken = getStoredAccessToken();
            if (newToken) {
                api.dispatch(setAuthToken(newToken));
            }

            return rawBaseQuery(args, api, { ...options, _retry: true });
        } catch {
            return result;
        }
    };
}
